<template>
  <div class="ExtraWorkDetails">
    <v-row>
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKarGheireMojaztatil")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_HOLINOTPERM)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKareMojazTatil")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_HOLIPERM)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKarAdiGheireMojaz")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_NORMNOTPERM)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKareAdiMojaz")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_NORMPERM)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKarTatilDarMamoriat")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_HoliInMission)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t(
            "PeriodWorkDetails.ExtraWorkDetails.lblEzafeKarGheireTatilDarMamoriat"
          )
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_NormInMission)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t(
            "PeriodWorkDetails.ExtraWorkDetails.lblEzafeKaregheirMojazDarVaghfe"
          )
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_BreakNotPerm)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKareMojazDarVaghfe")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_BreakPerm)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKareVijhe") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.EW_SPECIAL) }}</span
        ></v-col
      >
      <v-col cols="6"
        >{{
          $t("PeriodWorkDetails.ExtraWorkDetails.lblEzafeKarDarMamoriat")
        }}:<span class="text-value">{{
          ConvertMinuteToHour(details.EW_INMISSION)
        }}</span></v-col
      >
      <v-col cols="6"
        >{{ $t("PeriodWorkDetails.ExtraWorkDetails.lblKoleEzafeKar") }}:<span
          class="text-value"
          >{{ ConvertMinuteToHour(details.EXTRAWORKTOTAL) }}</span
        ></v-col
      >
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["details"],
};
</script>

<style>
</style>